// Third party import
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface sideMebuBarType {
  callMenuList: boolean;
  callRFUserList: boolean;
}

const initialState: sideMebuBarType = {
  callMenuList: true,
  callRFUserList: true};

export const sideMebuBarSlice = createSlice({
  name: "sideMenuBar",
  initialState,
  reducers: {
    setCallMenuList: (
      state: { callMenuList: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callMenuList = action.payload;
    },
    setCallRFUserList: (
      state: { callRFUserList: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callRFUserList = action.payload;
    }}});

export const { setCallMenuList, setCallRFUserList } = sideMebuBarSlice.actions;

export default sideMebuBarSlice.reducer;
